import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  AGREEMENT_LIST_ERROR,
  AGREEMENT_LIST_LOADING,
  AGREEMENT_LIST_RESET,
  AGREEMENT_LIST_PAGINATION,
  AGREEMENT_LIST_SUCCESS,
  AGREEMENT_LIST_ORDER,
  AGREEMENT_LIST_PAGE
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
  pagination: [],
  filter: {
    fullNumber: '',
    'customerData.name': ''
  },
  order: {
    field: 'fullNumber',
    direction: 'asc'
  },
  currentPage: 1
};

function error(error) {
  return {type: AGREEMENT_LIST_ERROR, error};
}

function loading(loading) {
  return {type: AGREEMENT_LIST_LOADING, loading};
}

function success(items) {
  return {type: AGREEMENT_LIST_SUCCESS, items};
}

function pagination(items) {
  return { type: AGREEMENT_LIST_PAGINATION, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
  pagination: state => state.pagination,
  order: state => state.order,
  filter: state => state.filter,
  currentPage: state => state.currentPage
};

const actions = {
    getItems: function({ commit, state }, page = '/agreements') {
      commit(loading(true));
      commit(error(null));
      return http.fetch(page + '?' + http.buildQueryParams(state.currentPage, state.order, state.filter))
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
          commit(pagination(data['hydra:pagination']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    },
    order: function(context, column) {
      context.commit(AGREEMENT_LIST_ORDER, column);
      context.dispatch('getItems');
    },
    changePage: function(context, page) {
      context.commit(AGREEMENT_LIST_PAGE, page);
      context.dispatch('getItems');
    }
};

const mutations = {
    [AGREEMENT_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [AGREEMENT_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [AGREEMENT_LIST_PAGINATION] (state, payload) {
      state.pagination = payload.items;
    },
    [AGREEMENT_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
    [AGREEMENT_LIST_RESET] (state) {
      state.items = [];
      state.currentPage = 1;
    },
    [AGREEMENT_LIST_ORDER] (state, column) {
      if (state.order.field == column && state.order.direction !== 'desc') {
        state.order.direction = 'desc';
      }
      else if (state.order.field == column && state.order.direction == 'desc') {
        state.order.field = '';
      }
      else {
        state.order.direction = 'asc';
        state.order.field = column;
      }
    },
    [AGREEMENT_LIST_PAGE] (state, page) {
       state.currentPage = page;
    }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/agreement/list.js